export const LOGIN_REQUEST='loginRequest';
export const LOGIN_SUCCESS='loginSuccess';
export const LOGIN_FAILURE='loginFailure';
